import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

const MotionLink = motion.create(Link);

const spans = {
  "biblioteca": "md:col-span-7",
  "pos-lojas": "md:col-span-5",
  "pos-restaurantes": "md:col-span-5",
  "custom": "md:col-span-7",
};

export const AppStore = () => {
  const [apps, setApps] = useState([]);
  useEffect(() => { api.get("/apps").then((r) => setApps(r.data)).catch(() => {}); }, []);

  return (
    <section id="produtos" className="py-24 md:py-40 bg-surface/30 border-y border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="mb-6">
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-white/50">A Loja</span>
            </div>
            <h2 className="font-head font-black text-4xl md:text-6xl tracking-tighter leading-none">Nossos Aplicativos</h2>
          </div>
          <p className="text-white/50 max-w-sm text-lg">Softwares prontos para instalar hoje. Ou um projeto sob medida para o que você imaginar.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6">
          {apps.map((a, i) => {
            const featured = a.id === "custom";
            return (
              <MotionLink
                key={a.id}
                to={`/app/${a.id}`}
                data-testid={`app-card-${a.id}`}
                initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: (i % 2) * 0.08 }}
                className={`${spans[a.id] || "md:col-span-6"} group relative flex flex-col justify-between p-8 md:p-10 min-h-[280px] border transition-all duration-500 hover:-translate-y-1 ${
                  featured ? "bg-cobalt border-cobalt hover:bg-[#0044CC]" : "bg-ink border-white/10 hover:border-white/30"
                }`}>
                <div className="flex items-start justify-between">
                  <span className={`font-mono text-xs uppercase tracking-[0.2em] ${featured ? "text-white/70" : "text-white/40"}`}>
                    {featured ? "Sob medida" : "App pronto"}
                  </span>
                  <ArrowUpRight className={`w-6 h-6 transition-transform duration-500 group-hover:rotate-45 ${featured ? "text-white" : "text-white/40 group-hover:text-white"}`} />
                </div>
                <div>
                  <h3 className="font-head font-bold text-2xl md:text-3xl tracking-tight mb-3">{a.name}</h3>
                  <p className={`mb-6 ${featured ? "text-white/80" : "text-white/50"}`}>{a.tagline}</p>
                  <div className="flex items-baseline gap-2">
                    <span className="font-head font-black text-3xl md:text-4xl">{a.price}</span>
                    {!featured && <span className="font-mono text-xs text-white/40">licença única</span>}
                  </div>
                </div>
              </MotionLink>
            );
          })}
        </div>
      </div>
    </section>
  );
};
